import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'

export const EmployeeGroupPopup = (props) => {
    return (
        <ModalBasic
            id="employeeGroup"
            classParams="!w-[55%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Employee group details</span>
                <div className='item-grp grid grid-cols-3 gap-2.5 mt-3 mb-3'>
                    <div className='input-grp'>
                        <label>Employee group no</label>
                        <TextInput type='number'
                            id='empGrpNo' name='empGrpNo'
                            value={props.employeeObject.empGrpNo}
                            handleChange={(event) => props.handleChange(event, 'empGrpNo')}
                            disabled
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Employee group name</label>
                        <TextInput type='text'
                            id='empGrpName' name='empGrpName'
                            value={props.employeeObject.empGrpName}
                            handleChange={(event) => props.handleChange(event, 'empGrpName')}
                            className={props.validState?.error?.empGrpName !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-3'>
                        <label>Group desc.</label>
                        <TextInput type='text'
                            id='grpDesc' name='grpDesc'
                            value={props.employeeObject.grpDesc}
                            handleChange={(event) => props.handleChange(event, 'grpDesc')}
                            className={props.validState?.error?.grpDesc !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-3'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.employeeObject.remarks}
                            handleChange={(event) => props.handleChange(event, 'remarks')}
                            className={props.validState?.error?.remarks !== undefined ? "error" : ""}
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}